/** 灯光颜色预置色板（图二 18 色，取自参考图截图，实现时逐格校对）
 *  仅联动 3D 预览（灯点光晕/光锥颜色），不参与生成——fal 模型无颜色入参（方案 §6） */
export const COLOR_SWATCHES: string[] = [
  '#8B5A2B', // 暖棕
  '#C19A6B', // 驼色
  '#B8860B', // 暗黄
  '#B22222', // 砖红
  '#FF0000', // 正红
  '#FFFFFF', // 白
  '#D3D3D3', // 浅灰
  '#6699CC', // 蓝灰
  '#4A4A4A', // 深灰
  '#7393B3', // 青灰
  '#14213D', // 藏蓝
  '#800080', // 紫
  '#FF3DCB', // 品红
  '#00E5FF', // 青绿
  '#00FF7F', // 绿
  '#FF8A3C', // 橙
  '#FFB35C', // 暖橙金
  '#5C7CFF', // 冷蓝
];
